import React, { useEffect, useState } from 'react';
import axios from 'axios';

export default function ContactMessages() {
  const [messages, setMessages] = useState([]);
  const [error, setError] = useState('');

  useEffect(() => {
    axios.get('/contact', { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } })
      .then(({ data }) => setMessages([...data].reverse()))
      .catch((err) => setError(err.response?.data?.message || 'Impossible de charger les messages.'));
  }, []);

  return (
    <main style={{ maxWidth: 1100, margin: '40px auto', padding: '0 24px', color: '#05012a' }}>
      <h1>Messages de contact</h1>
      <p style={{ color: '#666', marginBottom: 28 }}>Demandes envoyées depuis le formulaire public.</p>
      {error && <p style={{ color: '#b5122b' }}>{error}</p>}
      <div style={{ display: 'grid', gap: 18 }}>
        {messages.map((message) => (
          <article key={message.id} style={{ border: '1px solid #e4e4ec', borderRadius: 12, padding: 22, background: '#fff', color: '#05012a' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', gap: 16, flexWrap: 'wrap' }}>
              <strong style={{ color: '#05012a', fontSize: 18 }}>Objet : {message.subject}</strong>
              <span style={{ color: '#777' }}>{new Date(message.createdAt).toLocaleString('fr-FR')}</span>
            </div>
            <p style={{ lineHeight: 1.7, color: '#292541', whiteSpace: 'pre-wrap' }}>{message.message}</p>
            <div style={{ color: '#555' }}>
              <a href={`mailto:${message.email}`}>{message.email}</a> · <a href={`tel:${message.phoneNumber}`}>{message.phoneNumber}</a>
            </div>
          </article>
        ))}
        {!error && messages.length === 0 && <p>Aucun message pour le moment.</p>}
      </div>
    </main>
  );
}
